// const FormData = [
//     {
//         "field_type": "text",
//         "label": "Name",
//         "placeholder": "Enter name",
//         "default_value": "",
//         "min_length": 2,
//         "max_length": 30,
//         "is_multiline": false,
//         "is_required": true,
//         "is_unique": false,
//         "id": "a796bc38-9f6d-418b-a48d-a562e64ed990"
//     },
//     {
//         "field_type": "email",
//         "label": "Email",
//         "placeholder": "Enter email address",
//         "default_value": "",
//         "is_required": false,
//         "is_unique": false,
//         "id": "a8e34772-beb0-443c-86f4-cd0f79e4e546"
//     },
//     {
//         "field_type": "select",
//         "label": "Gender",
//         "placeholder": "Choose Gender",
//         "default_value": "option1",
//         "options": [
//             {
//                 "text": "Male",
//                 "value": "1"
//             },
//             {
//                 "text": "Female",
//                 "value": "2"
//             },
//             {
//                 "text": "No",
//                 "value": "3"
//             },
//             {
//                 "text": "Yes",
//                 "value": "4"
//             }
//         ],
//         "is_multiselect": true,
//         "is_required": true,
//         "is_unique": false,
//         "id": "cb4b4423-c072-4e02-a22a-86fb1e0dba3e"
//     },
// ]

const FormData = [
  {
    field_type: "text",
    label: "Name",
    placeholder: "Enter name",
    default_value: "",
    min_length: 2,
    max_length: 30,
    is_multiline: false,
    is_required: true,
    is_unique: false,
    id: "35356fb9-9007-495a-ba9e-925449cb3eb2",
  },
  {
    field_type: "email",
    label: "Email",
    placeholder: "Enter email address",
    default_value: "",
    is_required: false,
    is_unique: false,
    id: "4f4ac646-bf48-4ed3-ae5b-910071e19b59",
  },
  {
    field_type: "phone",
    label: "Phone",
    placeholder: "Enter phone number",
    default_value: "",
    is_required: false,
    is_unique: false,
    id: "500d8a78-e389-474d-831b-43190da011a6",
  },
  {
    field_type: "select",
    label: "Status",
    placeholder: "Choose option",
    default_value: "option1",
    options: [
      {
        text: "Active",
        value: "1",
      },
      {
        text: "Inactive",
        value: "0",
      },
    ],
    is_multiselect: false,
    is_required: true,
    is_unique: false,
    id: "fa44f220-0d82-4569-a28c-997de8e66d5a",
  },
  {
    field_type: "text",
    label: "Address",
    placeholder: "Enter address",
    default_value: "",
    min_length: 2,
    max_length: 30,
    is_multiline: false,
    is_required: true,
    is_unique: false,
    id: "d25f2f1b-811f-4c3d-a53b-5162f766ad47",
  },
  {
    field_type: "text",
    label: "Message",
    placeholder: "Enter message",
    default_value: "",
    min_length: 2,
    max_length: 30,
    is_multiline: false,
    is_required: true,
    is_unique: false,
    id: "22de0b1b-080a-4a0b-9d5f-e6f4916d8b07",
  },
];

export { FormData };
export default FormData;
